import {Transaction} from '../domain/Transaction'
import {Recurrence} from '../domain/Recurrence'

export type PersistableState = {
  oneTimeTransactions: Transaction[],
  persistedRecurringTransactions: Transaction[],
  recurrences: Recurrence[],
}

export const computePersistableState = (
  transactions: Transaction[],
  recurrences: Recurrence[],
): PersistableState => ({
  oneTimeTransactions: transactions.filter(t => !t.recurrenceId),
  persistedRecurringTransactions: transactions.filter(
    t => !!t.recurrenceId && (t.checked || (t.amountModifications?.length ?? 0) > 0),
  ),
  recurrences,
})
